import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Typography from '@material-ui/core/Typography'

const version = process.env.REACT_APP_VERSION

export const Version = ({ color }) =>
  version ? (
    <Footer>
      <Typography
        variant="body2"
        style={{ color: color }}>{`Version ${version}`}</Typography>
    </Footer>
  ) : (
    <div />
  )

Version.propTypes = {
  color: PropTypes.string
}

Version.defaultProp = {
  color: ''
}

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 10px;
  width: 100%;
`

export default Version



// WEBPACK FOOTER //
// ./src/components/Version/index.js